<script lang="ts" setup>
import type { TextareaHTMLAttributes } from 'vue';
import InputStyle from '~theme/components/atoms/styles/InputStyle.vue';

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    invalid?: boolean;
    autoResizeEnabled?: boolean;
    name?: TextareaHTMLAttributes['name'];
    placeholder?: TextareaHTMLAttributes['placeholder'];
    cols?: TextareaHTMLAttributes['cols'];
    rows?: TextareaHTMLAttributes['rows'];
    disabled?: TextareaHTMLAttributes['disabled'];
  }>(),
  {
    modelValue: '',
    invalid: false,
    autoResizeEnabled: false,
    name: '',
    placeholder: '',
    cols: 20,
    rows: 3,
    disabled: false,
  }
);

const emits = defineEmits<{
  'update:modelValue': [value: string];
}>();

const rows = ref(Number(props.rows));
const textareaElement = ref<HTMLElement>();

// コンポーネントに渡された rows で決まる高さからクロールしなくて済む最小の高さまで高さを拡張する
const fitHeightToContents = async () => {
  const elm = textareaElement.value;
  if (!elm) return;
  rows.value = Number(props.rows);
  await nextTick();
  let before = elm.clientHeight;
  while (elm.scrollHeight > elm.clientHeight) {
    rows.value = rows.value + 1;
    await nextTick();
    // max-height か height が設定されてる場合
    if (before === elm.clientHeight) return;
    before = elm.clientHeight;
  }
};

const value = computed({
  get(): string {
    return props.modelValue;
  },
  set(v: string) {
    emits('update:modelValue', v);
    if (props.autoResizeEnabled) fitHeightToContents();
  },
});
</script>

<template>
  <InputStyle :invalid="invalid">
    <textarea
      ref="textareaElement"
      v-model="value"
      :placeholder="placeholder"
      :name="name"
      :cols="cols"
      :rows="rows"
      :disabled="disabled"
      :class="$style.input"
    />
  </InputStyle>
</template>

<style lang="scss" module>
.input {
  appearance: none;
}
</style>
